import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BuilderRequest } from 'src/app/models/requests';
import { DocumentModel } from 'src/app/models/document.model';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { DossierService } from 'src/app/services/dossier.service';
import { ToastService } from 'src/app/services/toast.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';
import { LoggingService } from 'src/app/services/logging.service';
import { WorkflowStep1 } from 'src/app/models/workflow';
import { DocumentUpload } from 'src/app/models/documentUpload';
import { Subscription, lastValueFrom } from 'rxjs';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalOpenerService } from 'src/app/modals/modal-opener.service';
import { CloudLocationsService } from 'src/app/services/cloudlocations.service';
import { RequestBuilderApiClient } from 'src/app/services/api-clients/request-builder.api-client';
import { ChangeOrderModel } from 'src/app/models/api/change-order.model';
import { StringHelper } from 'src/app/directives/string-helper';
import { DefaultAllowedSafeTransferExtensions } from 'src/app/constants/settings.enum';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { RequestBuilderService } from '../request-builder.service';

@Component({
  selector: 'app-add-document',
  templateUrl: './adddocument.component.html'
})
export class AddDocumentComponent implements OnInit, OnDestroy {
  // @Input() 
  @Input() showKvKError: boolean | undefined = false;
  @Output('currentStep') step = new EventEmitter<string>();
  @Output('RequestChange') requestChange = new EventEmitter();
  @Output() getRequest: EventEmitter<string> = new EventEmitter<string>();
  @Output() AddMyselfEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() openPDFViewer = new EventEmitter();
  @Output() LoadThumbnail = new EventEmitter();

  requestId: string | null = this.route.snapshot.paramMap.get('requestId');
  translations: any = <any>{};
  orderDocuments: any = [];
  uploadProgress: number = 0;
  usersubscription: Subscription;
  workflowSubscription: Subscription;
  requestSubscription: Subscription;
  user!: User;
  filename!: string;
  docValue: string = "Xbrl only";
  allowedExtensions: string[] = [];
  signYourself: boolean = false;
  workflowData!: WorkflowStep1;
  request!: BuilderRequest;
  workflowId?: string;

  constructor(private toastService: ToastService,
    private route: ActivatedRoute,
    private dossierService: DossierService,
    private documentService: DocumentApiClient,
    private translateService: TranslateService,
    private loggingService: LoggingService,
    private authenticationService: AuthenticationService,
    private modalOpenerService: ModalOpenerService,
    private cloudLocationsService: CloudLocationsService,
    private requestBuilderApiClient: RequestBuilderApiClient,
    private organisationApiClient: OrganisationApiClient,
    private requestBuilderService: RequestBuilderService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.usersubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
    this.requestBuilderService.signYourselfWorkflow$.subscribe(signYourself => {
      this.signYourself = signYourself;
    })
    this.requestSubscription = this.requestBuilderService.request$.subscribe((request) => {
      this.request = request;
      this.workflowId = this.requestBuilderService.getWorkflowId();
    });
    this.workflowSubscription = this.requestBuilderService.workflowData$.subscribe(workflowData => {
      this.workflowData = workflowData.step1;
      if (this.workflowData && this.workflowData?.onlySpecifiedDocumentExtensions) {
        this.getAllowedDocumentExtensions();
      }
    });
  }
  ngOnDestroy(): void {
    if (this.usersubscription) {
      this.usersubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    if (!_.isEmpty(this.request)) this.requestId = this.request.id;
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  async createDossier(name: string) {
    try {
      let createDossier = await this.dossierService.createDossier(name, this.request?.workgroup, this.request?.clearancelevel, this.workflowId);
      let dossier: any = await lastValueFrom(createDossier);
      this.requestId = dossier.id;
      this.requestBuilderService.setRequestGuid(this.requestId!);
      this.request.jobName = name;
      this.request.id = dossier.id;

      this.appendCurrentUrlWithRequestId(this.requestId!);
      this.requestBuilderService.updateRequest(this.request);
    } catch (error: any) {
      this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsCreateDossierError + "")
    }
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.RequestDocumentDeleteError',
      'Toasts.CreateDossierError',
      'Toasts.CreateDocumentsError',
      'Toasts.UpdateDocumentError',
      'Toasts.CreateDuplicateDocumentsError',
      'Toasts.NoChamberOfCommerceNumberError',
      'Toasts.InvalidFileFormat',
      'Toasts.Error',
      'Toasts.KvKHeader',
      'Toasts.KvKBody',
      'Toasts.ProtectedDocument',
      'Toasts.ThisFiletypeIsNotAllowedByTheOrganisation',
      'Toasts.FileNameToLong70'
    ]).subscribe(translation => {
      this.translations.toastsRequestDocumentDeleteError = translation['Toasts.RequestDocumentDeleteError'];
      this.translations.toastsCreateDossierError = translation['Toasts.CreateDossierError'];
      this.translations.toastsCreateDocumentsError = translation['Toasts.CreateDocumentsError'];
      this.translations.toastsUpdateDocumentError = translation['Toasts.UpdateDocumentError'];
      this.translations.toastsCreateDuplicateDocumentsError = translation['Toasts.CreateDuplicateDocumentsError'];
      this.translations.toastsNoChamberOfCommerceNumberError = translation['Toasts.NoChamberOfCommerceNumberError'];
      this.translations.toastsInvalidFileFormat = translation['Toasts.InvalidFileFormat'];
      this.translations.error = translation['Toasts.Error'];
      this.translations.KvKHeader = translation['Toasts.KvKHeader'];
      this.translations.KvKBody = translation['Toasts.KvKBody'];
      this.translations.ProtectedDocument = translation['Toasts.ProtectedDocument'];
      this.translations.ThisFiletypeIsNotAllowedByTheOrganisation = translation['Toasts.ThisFiletypeIsNotAllowedByTheOrganisation'];
      this.translations.FileNameToLong70 = translation['Toasts.FileNameToLong70'];
    });
  }

  DocumentChange(event: any) {
    this.request.documentInfo[event.id].name = event.name;
    if (this.requestId != "") this.updateDocument(event.id).catch((error) => this.loggingService.logException(error));
    this.requestBuilderService.updateRequest(this.request);
  }

  async createDocuments(fileList: DocumentUpload[]) {
    if (fileList && fileList.length === 0) return;
    if (this.showKvKError) {
      this.toastService.showError(this.translations.KvKHeader, this.translations.KvKBody, 10000);
    }
    if (!fileList) {
      return;
    }

    let newHighestOrder: number = 0;
    if (this.request && this.request.documentInfo && this.request.documentInfo.length > 0) {
      let mapped = this.request.documentInfo.map(doc => doc.dossierIndex);
      newHighestOrder = Math.max(...mapped);
    }

    fileList.forEach((fileToUpload: DocumentUpload, index: number) => {
      let fileItem = fileToUpload;
      let fileExt: string = fileItem.file.name.toLocaleLowerCase().split('.').pop()!;
      if (this.allowedExtensions && this.allowedExtensions.length > 0 && !this.allowedExtensions.includes(fileExt)) {
        let invalidDocumentExtension = this.translateService.instant('Toasts.ThisFiletypeIsNotAllowedByTheOrganisation', { filename: fileItem.file.name });
        this.toastService.showError(this.translations.error, invalidDocumentExtension);
        // a continue, but for foreach its return:
        return;
      }


      let file: File = fileItem.file;
      this.filename = file.name;

      let formData = new FormData();
      formData.append('file', file, this.filename);
      if (fileItem.workflowPlaceholderId !== null && fileItem.workflowPlaceholderId !== undefined) formData.append('workflowPlaceholderId', fileItem.workflowPlaceholderId.toString());
      if (fileItem.dossierIndex !== null && fileItem.dossierIndex !== undefined) formData.append('dossierIndex', fileItem.dossierIndex.toString());
      else {
        newHighestOrder++;
        formData.append('dossierIndex', newHighestOrder.toString());
      }

      if (this.workflowData && !this.workflowData.allowRendering) formData.append('allowRendering', this.workflowData.allowRendering.toString());

      try {
        this.documentService.uploadNewDocument(this.requestId!, formData).subscribe({
          next: () => {
          },
          error: (error: any) => {
            this.errorHandling(error.error, this.filename);
            this.loggingService.logException(error);
          }
        });
      }
      catch (error: any) {
        if (error === "This filetype is not allowed by the organisation") {
          let invalidDocumentExtension = this.translateService.instant('Toasts.ThisFiletypeIsNotAllowedByTheOrganisation', { filename: fileItem.file.name });
          this.toastService.showError(this.translations.error, invalidDocumentExtension);
        } else {
          this.errorHandling(error, null);
        }
      }

    });

  }


  findLastIndex<T>(array: Array<T>, predicate: (value: T, index: number, obj: T[]) => boolean): number {
    let l = array.length;
    while (l--) {
      if (predicate(array[l], l, array))
        return l;
    }
    return -1;
  }

  async updateDocument(documentNumber: number) {
    (await this.documentService.updateDocument(this.requestId!, this.request.documentInfo[documentNumber].id, this.request.documentInfo[documentNumber].name)).subscribe({
      next: () => this.requestBuilderService.updateDocumentProgress(),
      error: (error: HttpErrorResponse) => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsUpdateDocumentError + ""),
    });
  }

  async DocumentDeleted(documentId: string) {
    let updateName = false
    if (this.request.documentInfo[this.request.documentInfo.findIndex(d => d.id === documentId)].name.split(".")[0] == this.request.jobName)
      updateName = true;
    this.request.documentInfo.splice(this.request.documentInfo.findIndex(d => d.id === documentId), 1);
    while (this.request.actors.findIndex(d => d.documentId === documentId) > -1) {
      this.request.actors.splice(this.request.actors.findIndex(d => d.documentId === documentId), 1);
    }
    if (updateName) {
      if (this.request.documentInfo.length > 0) {
        this.request.jobName = this.request.documentInfo[0].name.split(".")[0]
        this.requestBuilderService.updateRequest(this.request);
      } else {
        this.request.jobName = "";
        this.requestBuilderService.updateRequest(this.request);
      }
    }
    (await this.documentService.deleteDocument(this.requestId!, documentId)).subscribe({
      error: (error: HttpErrorResponse) =>
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsRequestDocumentDeleteError + ""),
      next: (data: any) => {
      }
    });
    this.requestBuilderService.updateDocumentProgress();
    this.requestBuilderService.updateRequest(this.request);
  }

  PlaceHolderDeleted(placeholderId: number) {
    this.workflowData?.placeholders?.splice(placeholderId, 1);
    this.requestBuilderService.updateDocumentProgress();
  }

  async OnFileSelectedWorkflow(event: any) {
    // Already have documents for this placeholder? FIRST update all indexes to 1 higher than selected:
    if (this.request?.documentInfo?.filter((s: DocumentModel) => s.workflowPlaceholderId! > event.workflowPlaceholderId).length > 0) {
      let newDocumentOrder: ChangeOrderModel[] = [];
      this.request?.documentInfo?.filter((s: DocumentModel) => s.workflowPlaceholderId! > event.workflowPlaceholderId).forEach((doc: DocumentModel, i: number) => {
        // map them to the model
        newDocumentOrder.push({ forGuid: doc.id, newOrder: doc.dossierIndex + event.event.target.files.length });
      });
      // Post
      (await this.requestBuilderApiClient.changeDocumentOrder(this.requestId!, newDocumentOrder)).subscribe({
        error: (error: HttpErrorResponse) => { },
        next: () => {
          // now select the file
          (async () => { await this.OnFileSelected(event.event, event.workflowPlaceholderId, event.dossierIndex) })();
        }
      });

    } else {
      // no files for this placeholder? just Select it
      await this.OnFileSelected(event.event, event.workflowPlaceholderId, event.dossierIndex);
    }
  }

  async OnFileSelected(event: any, workflowPlaceholderId: number | null = null, dossierIndex: number | null = null) {
    event.preventDefault();
    event.stopPropagation();
    let filelist: FileList = event.target.files;
    if (filelist == undefined) { filelist = event.dataTransfer.files }
    if (filelist.length < 1) return;

    let fileArray: File[] = Array.from(filelist);
    let files: DocumentUpload[] = [];
    fileArray.forEach((s: File) => {
      let documentUpload: DocumentUpload = {
        file: s,
        workflowPlaceholderId: workflowPlaceholderId,
        dossierIndex: dossierIndex
      };
      files.push(documentUpload);
      if (dossierIndex != null) dossierIndex++;
    });

    let i = 0;
    if (this.workflowData && !this.workflowData.placeholders && ((this.request.documentInfo ? this.request.documentInfo.length : 0) + files.length) > this.workflowData?.maxDocumentAmount) {
      let amountOfDocuments = (this.request.documentInfo ? this.request.documentInfo.length : 0) + files.length;
      let documentAboveMax = amountOfDocuments - this.workflowData?.maxDocumentAmount;
      files.splice(files.length - documentAboveMax);
      this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsCreateDocumentsError + "");
    }

    files.forEach((s: DocumentUpload) => {
      if (this.workflowData && this.workflowData.maxFileSizeMB && parseInt((s.file.size / 1048576).toFixed(0)) > this.workflowData.maxFileSizeMB) {
        files.splice(i, 1);
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsCreateDocumentsError + "");
      }
      i++;
    });

    if (_.isEmpty(this.request) || this.requestId === null || this.requestId === "") {
      let currentRequestName = this.request.jobName;
      // if no name was inserted by the user, try create the requestname from the selected file:
      if (currentRequestName == null) {
        var stringHelper = new StringHelper();
        currentRequestName = stringHelper.ParseFileNameToRequestName(filelist[0].name);
      }
      await this.createDossier(currentRequestName);
    }
    this.createDocuments(files).catch((error) => {
      this.loggingService.logException(error);
      this.errorHandling(error, null);
    });
    this.requestBuilderService.updateDocumentProgress();
    this.requestBuilderService.updateRequest(this.request);
  }

  async DocumentChangeOrder(event: any) {
    this.orderDocuments = this.request.documentInfo;
    moveItemInArray(this.orderDocuments, event.previousIndex, event.currentIndex);
    this.changeOrderDocuments().catch((error) => this.loggingService.logException(error));
  }

  async changeOrderDocuments() {
    // Get all documents and their (new) Indexes:
    let newDocumentOrder: ChangeOrderModel[] = [];
    for (let i = 0; i < this.orderDocuments.length; i++) {
      // map them to the model
      if (this.orderDocuments[i]) {
        newDocumentOrder.push({ forGuid: this.orderDocuments[i].id, newOrder: i });
      }
    }
    // Post
    this.requestBuilderApiClient.changeDocumentOrder(this.requestId!, newDocumentOrder).subscribe();
  }

  public GetRequest(event: string) {
    if (this.requestId === null || this.requestId === undefined) { this.requestId = event; this.appendCurrentUrlWithRequestId(this.requestId); }
    this.requestBuilderService.getRequestById(event);
  }

  private addMyself() {
    this.AddMyselfEmitter.emit();
  }

  errorHandling(error: string, filename: string | null) {
    let errorMessage = this.translations.toastsCreateDocumentsError;
    if (error === "Cannot add duplicate files to dossier") {
      errorMessage = this.translations.toastsCreateDuplicateDocumentsError;
    } else if (error === "No Chamber of Commerce number has been set") {
      errorMessage = this.translations.toastsNoChamberOfCommerceNumberError;
    } else if (error === "This file format is not supported.") {
      errorMessage = this.translations.toastsInvalidFileFormat;
    } else if (error.startsWith("Protected document with filename")) {
      errorMessage = this.translations.ProtectedDocument;
    }
    else if (error.indexOf("Name of document may not be longer") >= 0) {
      errorMessage = this.translations.FileNameToLong70;

    }
    this.toastService.showError("" + this.translations.error + "", "" + errorMessage + "");
  }

  openViewerEvent(event: any) {
    if (event.document && event.document.filetype.toLocaleLowerCase() == ".pdf") {
      this.openPDFViewer.emit({ documentId: event.document.id, actor: event.document.actors, actors: event.document.actors, place: false, displayfields: true, showEditDocument: true });
    } else if (event.document && (event.document.filetype.toLocaleLowerCase() == ".xbrl" ||
      event.document.filetype.toLocaleLowerCase() == ".html")) {
      this.modalOpenerService.Open_ViewXblrOrTxt(this.request, event.document);
    } else if (event.document.filetype.toLocaleLowerCase() == ".xml") {
      this.modalOpenerService.Open_ViewXml(this.requestId!, event.document);
    }
  }

  async uploadCloudDocuments(event: any) {
    if (!this.request.documentInfo) this.request.documentInfo = [];
    if (_.isEmpty(this.request) || this.requestId === null || this.requestId === "") {
      await this.createDossier(event.name);
    }
    await this.uploadCloudDocument(0, event);
  }

  private async uploadCloudDocument(index: number, event: any) {
    if (index >= event.externalFiles.length) return;

    let file = event.externalFiles[index];
    if (!this.request.documentInfo) this.request.documentInfo = [];
    try {
      let fileExt: string = event.name.toLowerCase().split('.').pop()!;
      if (this.allowedExtensions && this.allowedExtensions.length > 0 && !this.allowedExtensions.includes(fileExt)) {
        let invalidDocumentExtension = this.translateService.instant('Toasts.ThisFiletypeIsNotAllowedByTheOrganisation', { filename: event.name });
        this.toastService.showError(this.translations.error, invalidDocumentExtension);
        this.uploadCloudDocument(++index, event);
        return;
      }
      (await this.cloudLocationsService.importChildContents(event.provider, event.id, file, this.workflowData?.allowRendering, null, 1, this.request.id, event.workflowPlaceholderId, event.workflowId)).subscribe((responseObject: any) => {
        let doc: DocumentModel = new DocumentModel;
        doc.name = file;
        if (responseObject.type == HttpEventType.UploadProgress) {
          doc.documentStatus = "Uploading";
          doc.documentType = "Unknown";
          this.uploadProgress = Math.round((100 / responseObject.total) * responseObject.loaded);

          if (event.body == undefined) {
            doc.uploadProgress = this.uploadProgress;
            if (this.request.documentInfo.findIndex(s => s.name === doc.name) === -1) {
              this.request.documentInfo.push(doc);
            }
          }
          this.request.documentInfo.filter(s => s.name === doc.name)[0].uploadProgress = this.uploadProgress;
        } else if (responseObject.type == HttpEventType.Response) {
          let document = responseObject.body;

          let documentInfo = this.request.documentInfo.filter(s => s.name.toLowerCase() === file.toLowerCase())[0];
          documentInfo.id = document.guid;
          documentInfo.documentStatus = document.documentstatus;
          documentInfo.filetype = document.filetype;
          documentInfo.uploadProgress = 100;
          documentInfo.workflowPlaceholderId = event.workflowPlaceholderId ?? null;
          documentInfo.name = document.name;

          this.uploadCloudDocument(++index, event);
        }
      });
    }
    catch (error: any) {
      if (error === "This filetype is not allowed by the organisation") {
        let invalidDocumentExtension = this.translateService.instant('Toasts.ThisFiletypeIsNotAllowedByTheOrganisation', { filename: event.name });
        this.toastService.showError(this.translations.error, invalidDocumentExtension);
        this.uploadCloudDocument(++index, event);
      }
      this.loggingService.logException(error);
      this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsCreateDocumentsError + "");
    }
  }

  public appendCurrentUrlWithRequestId(requestId: string) {
    let url = new URL(window.location.href);
    url.pathname += "/" + requestId;
    let new_url = url.toString();
    window.history.pushState({}, '', new_url);
  }

  public loadThumbnail(event: Event) {
    this.LoadThumbnail.emit(event);
  }

  private async getAllowedDocumentExtensions() {
    this.organisationApiClient.getAllowedSafeTransferDocumentExtensions(this.user.organisationGuid).subscribe({
      next: (settings: any) => {
        this.allowedExtensions = settings;
      }, error: () => { this.allowedExtensions = DefaultAllowedSafeTransferExtensions }
    });
  }

}